<template>
<div class="main-body">
  <div class="main-body-search">
    <el-form :inline="true" :model="filters" @submit.native.prevent>
      <el-form-item>
        <el-select v-model="filters.orgType" placeholder="机构类别">
          <el-option
             v-for="item in residentOfficeTypes"
             :key="item.key"
             :label="item.value"
             :value="item.key">
           </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="filters.orgName" placeholder="机构名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="date" placeholder="创建时间起" style="width: 100%;" value-format="yyyy-MM-dd 00:00:00" v-model="filters.createTimeStart"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="date" placeholder="创建时间止" style="width: 100%;" value-format="yyyy-MM-dd 23:59:59" v-model="filters.createTimeEnd"></el-date-picker>
      </el-form-item>

      <el-tooltip placement="bottom" :content="$t('c.table.view')">
        <el-button v-show="actionValueAsComp < 3" type="primary" icon="el-icon-search" @click="searchMain(1)">{{ $t('c.table.view') }}</el-button>
      </el-tooltip>
    </el-form>
  </div>
  <el-main class="main-body-table">
    <el-table :data="mainTableData" @sort-change="sortChange" @row-dblclick="rowDblclick" @selection-change="handleSelectionChange" stripe>
      <el-table-column prop="id" fixed :label="$t('m.planActivity.id')" align="center"  width="180">
      </el-table-column>
      <el-table-column prop="residentOfficeName" show-overflow-tooltip label="机构名称" width="220">
      </el-table-column>
      <el-table-column prop="name" show-overflow-tooltip :label="$t('m.planActivity.name')"  width="180">
      </el-table-column>
      <el-table-column prop="activityType" show-overflow-tooltip :label="$t('m.planActivity.activityType')"  width="100">
      </el-table-column>
      <el-table-column prop="activeAddress" label="计划地点" align="center"  width="100">
      </el-table-column>
      <el-table-column prop="planHoldingTime" :label="$t('m.planActivity.planHoldingTime')" align="center"  width="130">
      </el-table-column>
      <el-table-column prop="actualHoldingTime" :label="$t('m.planActivity.actualHoldingTime')" align="center"  width="130">
      </el-table-column>


      <el-table-column  width="180" align="center">
        <template slot-scope="scope">
          <el-button size="small" @click="openDialog(ACTION.EDIT, scope.row, scope.$index)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页工具条-->
    <el-pagination class="main-body-table-page" layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"
      :current-page="pager.current" :page-size="pager.size" :total="total">
    </el-pagination>
  </el-main>
  <comp-plan-activity-query
    v-if="detailDialogVisible"
    :actionOfParent="currentAction"
    :currentTableRow="currentTableRow"
    :detailDialogVisible.sync="detailDialogVisible"
    @listenToDetailDialogClose="detailDialogCloseWithModified"
  >
  </comp-plan-activity-query>
</div>
</template>

<script>
import {
  selectPageplanActivityQuery,
} from '../../api/plan/PlanActivityQuery';
import CompPlanActivityQuery from '../../comp/planQuery/CompPlanActivity';
import dateUtil from '../../../common/js/util';
export default {
  name: 'planActivityQuery',
  props: {
    // 外键约束属性
    // 来自父组件指定的标题
    cardTitle: String,
    // 来自父组件的操作类型参数
    actionOfParent: Object
  },
  components: {
    CompPlanActivityQuery,
  },
  data() {
    return {
      residentOfficeTypes: [],
      // 主表记录总数
      total: 0,
      // 分页及查询对象
      pager: {
        current: 1,
        size: 10
      },
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      // 当前主表行记录
      currentTableRow: {},
      // 当前主表中选中的行记录
      selectedRows: [],
      // 主表数据
      mainTableData: [],
      // 作为组件时的操作类型, 根据父组件变动, 默认为2:编辑
      actionValueAsComp: 2,
      // 当前组件是否已经有服务端更新
      modified: false,
      // 对话框显示隐藏控制
      detailDialogVisible: false,
      // 查询条件
      filters: {
        createTimeStart: dateUtil.formatDate((new Date(new Date()-1000*60*60*24*90)), 'yyyy-MM-dd 23:59:59', 0), //创建时间起
        createTimeEnd: dateUtil.formatDate((new Date()), 'yyyy-MM-dd 23:59:59', 0) //创建时间止
      },
    };
  },
  computed: {
    // 操作类型常量
    ACTION: function () {
      return {
        NEW: { value: 1, name: this.$t('c.table.new') },
        EDIT: { value: 2, name: this.$t('c.table.edit') },
        VIEW: { value: 3, name: this.$t('c.table.view') },
        UPLOAD: {value: 4, name: this.$t('c.table.upload') }
      }
    }
  },
  // 页面首次加载数据
  mounted() {
    if (this.actionOfParent) {
      this.actionValueAsComp = this.actionOfParent.value;
    }
    // 获取当前用户可使用的机构类型
    this.residentOfficeTypes = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))
    // 默认取 - 获取当前用户可使用的机构类型第一个值
    this.filters.orgType = JSON.parse(sessionStorage.getItem('dynamicResidentOfficeTypes'))[0].key
    this.searchMain(1);
  },
  methods: {
    /**
     * 点击列标题排序
     * @param column 点击排序的列对象
     */
    sortChange: function(column) {
      this.pager.prop = column.prop;
      this.pager.order = column.order;
      this.searchMain(1);
    },
    /**
     * 主表勾选记录事件
     * @param {Array} rows 当前选中的记录列表
     */
    handleSelectionChange: function(rows) {
      this.selectedRows = rows;
    },
    /**
     * 更新成功后的关闭对话框事件
     * @param {ACTION} action 操作类型
     */
    detailDialogCloseWithModified: function(action) {
      if (action.value === 1) {
        // NEW
        this.searchMain(1);
      } else if (action.value === 2) {
        // EDIT
        this.searchMain();
      }
      this.$emit('listenToCompModifiedEvent');
    },
    /**
     * 主表每页记录数调整后的查询
     * @param size int 调整后的每页记录数
     */
    handleSizeChange(size) {
      this.pager.size = size;
      this.searchMain();
    },
    /**
     * 主表翻页查询
     * @param current int 指定查询页号
     */
    handleCurrentChange(current) {
      this.pager.current = current;
      this.searchMain();
    },
    /**
     * 分页主表查询
     * @param current int 可选参数，查询指定页的数据
     * current: 不传值或传null/undefined/0，表示翻页
     * current: 大于等于1表示重新查询该页
     *    例如：更新某记录后重新加载当前页
     *    例如：删除某记录、查询文本框回车、查询按钮点击则传1，重新查询第1页
     */
    searchMain(current) {
      if (current && current >= 1) {
        // 重新查询该页
        this.pager.current = current;
      }
      this.fetchMainTable();
    },
    /**
     * 分页查询主表数据
     */
    fetchMainTable() {
      this.filters.current = this.pager.current;
      this.filters.size = this.pager.size;
      this.filters.fuzzyText = this.pager.fuzzyText;
    //  this.filters.residentOffice = 'root';
      selectPageplanActivityQuery(this.filters).then(result => {
        this.total = result.total;
        this.mainTableData = result.data;
      });
    },

    /**
     * 表格行双击事件打开查看对话框
     * @param row 双击的行记录对象
     * @param event 鼠标事件
     * @param column 双击的列对象
     */
    rowDblclick(row) {
      this.openDialog(this.ACTION.VIEW, row)
    },
    /**
     * 打开对话框
     * @param action ACTION.NEW/ACTION.EDIT/ACTION.VIEW
     * @param row 行记录对象，新增时为空
     * @param indexOfRow 行索引号，新增时为空
     */
    async openDialog(action, row) {
      this.currentTableRow = Object.assign({}, row || this.getDefaultFormModel());
      this.currentAction = action;
      this.detailDialogVisible = true;
    },
    /**
     * 设置新增对话框表单中的默认值
     * @returns 默认值对象
     */
    getDefaultFormModel() {
      return {

      };
    }
  }
}
</script>

<style lang="scss"></style>
